import revive_payload_client_4sVQNw7RlN from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/root/workspace/exam-lib-fe_qgLR/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/root/workspace/exam-lib-fe_qgLR/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import xss_HdIDVasF86 from "/root/workspace/exam-lib-fe_qgLR/modules/nuxt-xss/runtime/plugins/xss.ts";
import element_plus_teleports_plugin_h4Dmekbj62 from "/root/workspace/exam-lib-fe_qgLR/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/root/workspace/exam-lib-fe_qgLR/.nuxt/element-plus-injection.plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/root/workspace/exam-lib-fe_qgLR/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import _00_appInit_F50cjECmgY from "/root/workspace/exam-lib-fe_qgLR/plugins/00.appInit.ts";
import arms_KhuhjXBvMv from "/root/workspace/exam-lib-fe_qgLR/plugins/arms.ts";
import decodeRichText_RcSM3TC0eH from "/root/workspace/exam-lib-fe_qgLR/plugins/decodeRichText.ts";
import error_ldt3PQauZ0 from "/root/workspace/exam-lib-fe_qgLR/plugins/error.ts";
import globalComponent_I9KZfdzYDZ from "/root/workspace/exam-lib-fe_qgLR/plugins/globalComponent.ts";
import shence_dAglSyMzWw from "/root/workspace/exam-lib-fe_qgLR/plugins/shence.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  xss_HdIDVasF86,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  chunk_reload_client_UciE0i6zes,
  _00_appInit_F50cjECmgY,
  arms_KhuhjXBvMv,
  decodeRichText_RcSM3TC0eH,
  error_ldt3PQauZ0,
  globalComponent_I9KZfdzYDZ,
  shence_dAglSyMzWw
]